import axios from '../utils/axios';

export default {
  getAll() {
    return axios.get(`${process.env.REACT_APP_ROOT_API}monedas`, {
      data: {}
    });
  },
  getTotalDolares(valor, moneda) {
    return axios.get(`${process.env.REACT_APP_ROOT_API}monedas/total-dolar`, {
      data: {},
      params: { valor, moneda }
    });
  }
};
